import { esES, enUS, ptBR, frFR, nlNL, zhCN, deDE } from '@mui/x-data-grid-pro';
import {
  esES as esCore,
  ptBR as ptCore,
  frFR as frCore,
  enUS as enCore,
  nlNL as nlCore,
  zhCN as zhCore,
  deDE as deCore,
} from '@mui/material/locale';

export const SUPPORTED_TRANSLATIONS = {
  es: [esES, esCore],
  pt: [ptBR, ptCore],
  fr: [frFR, frCore],
  nl: [nlNL, nlCore],
  zh: [zhCN, zhCore],
  de: [deDE, deCore],
  default: [enUS, enCore],
};
